import Auth from '@/router/auth'
import App from '@/router/app'
import { IRouteConfigWithMeta } from '@/router/interfaces'

export default [
  ...Auth,
  ...App,
  {
    path: '/404',
    name: '404'
  },
  {
    path: '/403',
    name: '403'
  }
] as IRouteConfigWithMeta[]
